export default "__VITE_ASSET__DTrU55Eg__"